import React from 'react';
import { Hero } from '../components/sections/Hero';
import { NarrativeBlock } from '../components/sections/NarrativeBlock';
import { TargetAudience } from '../components/sections/TargetAudience';
import { Benefits } from '../components/sections/Benefits';
import { Mechanism } from '../components/sections/Mechanism';
import { PackageIncludes } from '../components/sections/PackageIncludes';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { CTAButton } from '../components/ui/CTAButton';
import { ContentSection } from '../components/ui/ContentSection';
import { motion } from 'framer-motion';
export function LandingPage() {
  return <main className="min-h-screen bg-[#FAFAFA] text-[#1A1A1A] font-sans selection:bg-amber-100 selection:text-amber-900" data-id="element-178">
      <Hero data-id="element-179" />

      <NarrativeBlock label="IDENTIFICACIÓN / ESPEJO" title="El cansancio que no se quita durmiendo" background="white" image="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_j5wmbkj5wmbkj5wm_yif0an.png" imageAlt="Visualización del cansancio y dispersión" imagePosition="right" data-id="element-180">
        <p data-id="element-181">
          Hay un tipo de cansancio que no viene del trabajo. Viene de decidir
          todo el día, vivir reaccionando, apagar fuegos, decir "sí" a
          demasiadas cosas y dejar lo importante para después.
        </p>
        <p className="font-bold text-gray-900 text-xl my-6" data-id="element-182">
          No estás cansada. Estás dispersa.
        </p>
        <p data-id="element-183">
          Y cuando una persona disciplinada se dispersa, pasa algo peligroso: Se
          vuelve eficiente… pero en lo equivocado.
        </p>
      </NarrativeBlock>

      <NarrativeBlock label="PROBLEMA CENTRAL" title="La verdad incómoda que casi nadie te dice" background="gray" data-id="element-184">
        <p data-id="element-185">
          Hacer más ya no es la respuesta. De hecho, hacer más desde el mismo
          nivel suele provocar más presión, menos claridad, menos energía y la
          sensación de correr sin avanzar.
        </p>
        <p className="text-xl font-medium text-gray-900 mt-6" data-id="element-186">
          El avance real no se improvisa. Se diseña. Y se protege.
        </p>
      </NarrativeBlock>

      <NarrativeBlock label="REVELACIÓN" title="El techo invisible" background="white" image="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_noqzcmnoqzcmnoqz_ffp9yb.png" imageAlt="Concepto del techo invisible" imagePosition="left" data-id="element-187">
        <p data-id="element-188">
          Llega un punto —especialmente si eres responsable— en el que aparece
          un techo. No es falta de talento. No es falta de disciplina. No es
          falta de ganas.
        </p>
        <p className="my-6" data-id="element-189">
          Es un techo invisible. Trabajas más… pero el crecimiento deja de
          sentirse proporcional. Ahí es donde muchas personas se frustran. O se
          resignan.
        </p>
        <p className="font-bold text-amber-600" data-id="element-190">
          Y otras deciden subir de nivel.
        </p>
      </NarrativeBlock>

      <NarrativeBlock label="PREGUNTA BISAGRA" title="La pregunta que lo cambia todo" background="gray" highlight data-id="element-191">
        <p className="text-xl mb-6" data-id="element-192">
          Hay una pregunta incómoda, pero ordenadora:
        </p>
        <h3 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-193">
          ¿Cuánto vale una hora de tu vida?
        </h3>
        <p data-id="element-194">
          Porque cuando no sabes cuánto vale tu hora: la regalas, la llenas de
          cosas que no suman, la entregas a lo urgente y la postergas por
          costumbre.
        </p>
        <p className="mt-6 font-medium" data-id="element-195">
          Y sin darte cuenta, no pierdes un día. Pierdes años.
        </p>
      </NarrativeBlock>

      <ContentSection background="white" data-id="element-196">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-197">
          <div data-id="element-198">
            <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-199">
              SOLUCIÓN
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6" data-id="element-200">
              Esto no es motivación. <br data-id="element-201" />
              <span className="text-gray-500" data-id="element-202">Es un sistema de claridad.</span>
            </h2>
            <div className="prose prose-lg text-gray-600 mb-8" data-id="element-203">
              <p data-id="element-204">
                <strong data-id="element-205">Juega Desde Otro Nivel</strong> no es un libro para
                empujarte a aguantar más. Es un libro para ayudarte a ver con
                claridad, ordenar decisiones, proteger tu energía y enfocar tu
                tiempo.
              </p>
              <p data-id="element-206">
                No se trata de trabajar menos. Se trata de trabajar desde otro
                nivel.
              </p>
            </div>
            <CTAButton href="https://coneckta.co/ebookjuegadesdeotronivel" data-id="element-207">
              Quiero jugar desde otro nivel
            </CTAButton>
          </div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative" data-id="element-208">
            <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1766234477/Gemini_Generated_Image_j7ylibj7ylibj7yl_rz5r9k.png" alt="Libro Juega Desde Otro Nivel" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-209" />
          </motion.div>
        </div>
      </ContentSection>

      <TargetAudience data-id="element-210" />

      <Benefits data-id="element-211" />

      <Mechanism data-id="element-212" />

      <ContentSection background="white" data-id="element-213">
        <div className="text-center max-w-3xl mx-auto" data-id="element-214">
          <span className="text-amber-600 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-215">
            CÓMO SE USA
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-8" data-id="element-216">
            ¿Cómo se usa este libro?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-217">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-218">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-219">
                01
              </span>
              <p className="font-medium text-gray-900" data-id="element-220">
                Lo lees en bloques cortos
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-221">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-222">
                02
              </span>
              <p className="font-medium text-gray-900" data-id="element-223">
                Cada capítulo incluye una pregunta clave
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-224">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-225">
                03
              </span>
              <p className="font-medium text-gray-900" data-id="element-226">
                Aplicas el filtro el mismo día
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-227">
              <span className="text-amber-500 font-bold text-xl block mb-2" data-id="element-228">
                04
              </span>
              <p className="font-medium text-gray-900" data-id="element-229">
                No necesitas terminarlo para ver claridad
              </p>
            </div>
          </div>
          <p className="mt-8 text-xl font-medium text-gray-900" data-id="element-230">
            Diseñado para personas ocupadas. Pensado para aplicar, no acumular.
          </p>
        </div>
      </ContentSection>

      <PackageIncludes data-id="element-231" />

      <FAQ data-id="element-232" />

      <FinalCTA data-id="element-233" />

      <footer className="bg-[#FAFAFA] py-12 text-center text-gray-400 text-sm" data-id="element-234">
        <p data-id="element-235">
          © {new Date().getFullYear()} Juega Desde Otro Nivel. Todos los
          derechos reservados.
        </p>
      </footer>
    </main>;
}